import React, { useState, useEffect, useRef } from 'react';
import { ThemeColors } from '../../../../Context/ThemeContext';
import type { PeriodOption } from '../types';

export type { PeriodOption };

interface PeriodDropdownProps {
  value: PeriodOption;
  onChange: (value: PeriodOption) => void;
  theme: ThemeColors;
  style?: React.CSSProperties;
  options?: PeriodOption[];
}

export const PeriodDropdown: React.FC<PeriodDropdownProps> = ({
  value,
  onChange,
  theme,
  style,
  options = ['1D', '7D', '30D', '90D'],
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} style={{ position: 'absolute', zIndex: 10, ...style }}>
      <button
        onClick={() => value !== 'custom' && setIsOpen(!isOpen)}
        style={{
          background: '#2563eb',
          color: '#fff',
          padding: '2px 8px',
          borderRadius: '4px',
          fontSize: '11px',
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          border: 'none',
          cursor: value === 'custom' ? 'default' : 'pointer',
          opacity: value === 'custom' ? 0.7 : 1,
        }}
      >
        {value === 'custom' ? 'Custom' : value}
        <span
          style={{
            fontSize: '8px',
            transform: isOpen ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.2s',
          }}
        >
          ▼
        </span>
      </button>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '24px',
            right: '0',
            background: theme.card,
            border: `1px solid ${theme.border}`,
            borderRadius: '4px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            overflow: 'hidden',
            minWidth: '60px',
          }}
        >
          {options.map((option) => (
            <button
              key={option}
              onClick={() => {
                onChange(option);
                setIsOpen(false);
              }}
              style={{
                display: 'block',
                width: '100%',
                padding: '8px 12px',
                background: value === option ? '#2563eb' : 'transparent',
                color: value === option ? '#fff' : theme.text,
                border: 'none',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: 500,
                textAlign: 'left',
              }}
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
